module.exports = __webpack_public_path__ + "img/4.9481c18c.jpg";